faq.component('faq.faqComponent', {
    templateUrl: 'faq/faq.html',
    controller: 'faq.faqController',
    controllerAs: '$ctrl'
});

faq.controller('faq.faqController', ['$scope', 'coreLanguage', '$state', 'coreFb', '$timeout', '$filter', function($scope, $text, $state, $fb, $timeout, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.filter = {};
    $ctrl.tableObj = {};

    const _tableRerender=()=>{
        let config = angular.copy($ctrl.tableObj);
        $ctrl.tableObj = null;
        $timeout(()=>{ $ctrl.tableObj = config; }, 100);
    };

    const _getFaq=()=>{
        $fb.db.get(`cad_faq/${$state.params.idFaq}`).then((doc)=>{
            $ctrl.faq = doc;  
            _getArtigos();
        });
    };

    const _getArtigos=()=>{

        $fb.db.list(`cad_faq/${$state.params.idFaq}/artigos`).then((list)=>{

            $ctrl.tableObj.data = list.map((item)=>{
                return {
                    titulo: item.data.titulo || null,
                    descricao: item.data.descricao || null,
                    idProduto: item.data.idProduto || null,
                    idModulo: item.data.idModulo || null,
                    produtoNome: null,
                    moduloNome: null,
                    indice: item.data.titulo,
                    docPath: item.path
                }
            });
            
            _getDominio();
        });

    };

    const _getDominio=()=>{
        $fb.db.list('cad_produtos', [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}]).then(list=>{
            $ctrl.produtoOptions = list.map((item)=>{ return {id:item.id, nome: item.data.nome, niveis: item.data.niveis }});
            $ctrl.produtoOptions.unshift({id:'all', nome:$text.all, niveis:[$text.all, 'starter', 'pro', 'partner']});

            return new Promise(async(resolve)=>{

                for(let item of $ctrl.produtoOptions){
                    if(item.id !== 'all'){
                        
                        let modList = await $fb.db.list(`cad_produtos/${item.id}/modulos`);

                        item.modulos = modList.map((mod)=>{ return {id:mod.id, nome: mod.data.nome} });
                        item.modulos.unshift({id:'all', nome:$text.all});
                    }else{
                        item.modulos =[{id:'all', nome:$text.all}];
                    }
                }

                resolve();

            });

            
        }).finally(()=>{
            $ctrl.cfgArtigos.options = $ctrl.produtoOptions;
            $state.params.showGlobalLoading = false;
            _checkNomeProduto();
        });
    };

    const _checkNomeProduto=()=>{
        
        const __getProdutoNome=(id)=>{
            if(id === 'all'){
                return $text.all;
            }

            if($ctrl.produtoOptions && $ctrl.produtoOptions.length){
                return $filter('filter')($ctrl.produtoOptions, {id:id})[0]?.nome || $text.notDefined;
            }
        };
        
        const __getModuloNome=(idProd, idMod)=>{

            if(!idProd || !idMod){
                return;
            }

            if(idMod === 'all'){
                return $text.all;
            }

            if($ctrl.produtoOptions && $ctrl.produtoOptions.length){                
                let hasProduto = $filter('filter')($ctrl.produtoOptions, {id:idProd});

                if(hasProduto.length && hasProduto[0].modulos.length){
                    let hasModulo = $filter('filter')(hasProduto[0].modulos, {id:idMod});
                    return hasModulo[0] ? hasModulo[0].nome : $text.notDefined;
                }
            }
        };

        if(!$ctrl.tableObj || !$ctrl.produtoOptions.length){
            return;
        };

        $ctrl.tableObj.data.forEach((item)=>{ 
            item.produtoNome = __getProdutoNome(item.idProduto);
            item.moduloNome = __getModuloNome(item.idProduto, item.idModulo);
        });

        _tableRerender();

    };

    const _confirmArtigo=()=>{
        $state.params.showGlobalLoading = true;

        const __cleanRegistro=(reg)=>{
            delete reg.moduloNome;
            delete reg.produtoNome;
            delete reg.docPath;

            return reg;
        };

        let obj = __cleanRegistro($ctrl.cfgArtigos.dados);

        if($ctrl.cfgArtigos.dados.docPath){
            $fb.db.update($ctrl.cfgArtigos.dados.docPath, obj)
            .then(okay=>{ $state.reload(); });
        }else{
            $fb.db.add(`cad_faq/${$state.params.idFaq}/artigos`, obj)
            .then(okay=>{ $state.reload(); });
        };

    };

    const _deleteArtigo=()=>{

        $ctrl.cfgArtigos.isLoading=true;

        if($ctrl.cfgArtigos.dados.docPath){
            $fb.db.del($ctrl.cfgArtigos.dados.docPath).then((res)=>{
                $ctrl.cfgArtigos.show = false;
                $ctrl.cfgArtigos.isLoading=false;

                $state.reload();
            });
        }

    };

    $ctrl.setTableFilter=(value, field)=>{
        if(field==="search"){
            if(!value.length){
                delete $ctrl.filter.indice;
            }else{
                $ctrl.filter.indice = value;
            }
        }else{
            if(!!value){
                $ctrl.filter[field] = value;
            }else{
                delete $ctrl.filter[field];
            }
        }
    };

    $ctrl.setViewForm=(value)=>{
        $ctrl.viewForm = value;
    };

    $ctrl.submit=()=>{
        if(!$ctrl.faq.data.nome){
            return;
        }

        $fb.db.update($ctrl.faq.path, {nome: $ctrl.faq.data.nome, subtitulo: $ctrl.faq.data.subtitulo})
        .then((okay)=>{ $state.reload(); });

    };

    const _editRegistroModal=(dados)=>{
        $ctrl.cfgArtigos.dados = angular.copy(dados);
        $ctrl.cfgArtigos.title = $text.edit;
        $ctrl.cfgArtigos.show = true;
    };

    $ctrl.addRegistroModal=()=>{
        $ctrl.cfgArtigos.dados = {};
        $ctrl.cfgArtigos.title = $text.add;
        $ctrl.cfgArtigos.show = true;
    };

    $ctrl.tableObj = {
        pageSize: 100,
        pageCount: 1,
        columns:[
            {title: $text.title.toUpperCase(), width:'25%', key:'titulo', type:'text', export:true},
            {title: $text.product.toUpperCase(), key:'produtoNome', type:'text', export:true},
            {title: $text.module.toUpperCase(), key:'moduloNome', type:'text', export:true}
        ],
        data:[],
        actions:{
            enable: {edit:true, view:true, delete:true},
            edit: _editRegistroModal,
            view: _editRegistroModal
        },
        bulkActions:{
            enable: {delete:true}
        }
    };

    $ctrl.cfgArtigos = {
        show:false,
        dados: {},
        isLoading:false,
        enableDelete:true,
        options: [],
        confirm: _confirmArtigo,
        delete: _deleteArtigo
    };

    $ctrl.$onInit = () => {
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idMaster || $fb.auth.getIdToken().claims.idUsuario;

        _getFaq();
    }
    
}]);